<div class="transaction-details-modal">
    <div class="modal-body">
        <!-- Status and Amount Section -->
        <div class="transaction-header">
            <div class="status-badge" [class]="getStatusClass(transaction.status)">
                <div class="status-icon">
                    <img src="assets/icons/information-polygon.svg" alt="status" />
                </div>
                <div class="status-text">{{ transaction.status }}</div>
            </div>

            <div class="transaction-amount">
                {{ transaction.amount }}
                <span>{{ transaction.currency }}</span>
            </div>

            <div class="transaction-datetime">
                <span class="date">{{ transaction.date }}</span>
                <span class="time">{{ transaction.time }}</span>
            </div>
        </div>

        <!-- Transaction Details List -->
        <div class="transaction-details-list">
            <div class="detail-item">
                <div class="detail-label">Identifier</div>
                <div class="detail-value">{{ transaction.identifier }}</div>
            </div>
            <div class="detail-divider"></div>

            <div class="detail-item">
                <div class="detail-label">Name</div>
                <div class="detail-value">{{ transaction.name }}</div>
            </div>
            <div class="detail-divider"></div>

            <div class="detail-item">
                <div class="detail-label">Card</div>
                <div class="detail-value">{{ transaction.card }}</div>
            </div>
            <div class="detail-divider"></div>

            <div class="detail-item">
                <div class="detail-label">Category</div>
                <div class="category-badge">
                    <div class="category-icon">
                        <img src="assets/icons/pencil.svg" alt="category" />
                    </div>
                    <div class="category-text">{{ transaction.category }}</div>
                </div>
            </div>
        </div>
    </div>
</div>